import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-signal-strength',
  templateUrl: './signal-strength.component.html',
  styleUrls: ['./signal-strength.component.scss']
})
export class SignalStrengthComponent implements OnChanges {

  @Input() signal: number | null;
  @Input() isMeasurement: boolean;
  @Input() bandType: string;
  @Input() imei: string;
  public strength: number;

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (this.signal === null || this.signal === undefined || this.signal === 200) {
      this.isMeasurement = false;
      this.strength = 0;
      return;
    }

    this.strength = this.getSignalLevel();

    if (this.strength > 0) {
      this.isMeasurement = true;
    }
  }

  public getSignalLevel(): number {
    const signalValue = Math.abs(this.signal);
    if (this.bandType === 'VITAL CARE') {
      if (signalValue >= 94 ) {
        return 1;
      } else if (signalValue >= 89 && signalValue < 94) {
        return 2;
      } else if (signalValue >= 80 && signalValue < 89) {
        return 3;
      } else if (signalValue >= 70 && signalValue < 80) {
        return 4;
      } else if (signalValue < 70) {
        return 5;
      } else {
        return 0;
      }
    } else {
      if (signalValue > 119) {
        return 0;
      } else if (signalValue >= 105 && signalValue <= 119) {
        return 1;
      } else if (signalValue >= 92 && signalValue < 105) {
        return 2;
      } else if (signalValue >= 78 && signalValue < 92) {
        return 3;
      } else if (signalValue >= 64 && signalValue < 78) {
        return 4;
      } else {
        return 5;
      }
    }
  }

}
